import { getTeam } from '../lib/apilib'
import { useEffect, useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import Loader from '../components/loader'
import useTeamCodes from '../lib/teamCodes'
import { TiStarFullOutline } from 'react-icons/ti'
import RatingNum from '../components/RatingNum'
import { FaSortDown } from 'react-icons/fa'
import useRegionColors from '../lib/regionColors'
import RatioBar from '../components/rankings/RatioBar'
import DoubleSlider from '../components/DoubleSlider'
import RankingDisplay from '../components/rankings/TeamPage/RankingDisplay'
import { useMobileDetect, useSmallScreen } from '../lib/hooks'

const ratingTypes = {
  openrating: { type: 'open', raceType: 'fleet', label: 'Open Fleet' },
  womenrating: { type: 'women', raceType: 'fleet', label: "Women's" },
  teamrating: { type: 'open', raceType: 'team', label: 'Team Race' },
  wteamrating: { type: 'women', raceType: 'team', label: "Women's TR" },
}

export default function TeamRankings() {
  const { teamName } = useParams()
  const smallScreen = useSmallScreen()
  const mobile = useMobileDetect() || smallScreen
  const [rating, setRating] = useState(1500)
  const [teamData, setTeamData] = useState({})
  const [teamMembers, setTeamMembers] = useState([])
  const [teamLink, setTeamLink] = useState('')
  const [teamRegion, setTeamRegion] = useState('')
  const [recentRegattas, setRecentRegattas] = useState([])
  const [loaded, setLoaded] = useState(false)

  const [sort, setSort] = useState('openrating')
  const [ratingView, setRatingView] = useState('openrating') // rating column shown on mobile
  const [activeSeasons, setActiveSeasons] = useState([])
  const [allSeasons, setAllSeasons] = useState([])
  const teamCodes = useTeamCodes()
  const regionColors = useRegionColors()
  const debug = false

  const [selectionMode, setSelectionMode] = useState(mobile ? 'advanced' : 'default')

  useEffect(() => {
    getTeam(teamName).then((tempTeam) => {
      if (tempTeam === undefined) return
      // console.log(tempTeam)
      setTeamMembers(tempTeam.members)
      setRating(tempTeam.data.avgRating)
      setTeamLink(tempTeam.data.link)
      setTeamRegion(tempTeam.data.region)
      setRecentRegattas(tempTeam.regattas)
      setTeamData(tempTeam.data)

      const allSeasons = tempTeam.members.map((member) => member.season)
      const uniqueSeasons = [...new Set(allSeasons)].sort((a, b) => {
        if (parseInt(a.slice(1, 3)) - parseInt(b.slice(1, 3)) !== 0) {
          return parseInt(a.slice(1, 3)) - parseInt(b.slice(1, 3))
        } else if (a.slice(0, 1) === 's' && b.slice(0, 1) === 'f') {
          return -1
        } else {
          return 1
        }
      })
      setActiveSeasons([uniqueSeasons[uniqueSeasons.length - 1]])
      setAllSeasons(uniqueSeasons)
      if (tempTeam.data.region !== '') {
        document.querySelector(':root').style.setProperty('--highlight1', regionColors[tempTeam.data.region])
      }
      setLoaded(true)
    })
  }, [teamName])
  useEffect(() => {
    setSelectionMode(mobile ? 'advanced' : 'default')
  }, [mobile])

  const getRating = (member, pos, type, raceType) => {
    const ratingMap = {
      skipper: {
        fleet: { open: 'sr', women: 'wsr' },
        team: { open: 'tsr', women: 'wtsr' },
      },
      crew: {
        fleet: { open: 'cr', women: 'wcr' },
        team: { open: 'tcr', women: 'wtcr' },
      },
    }

    const key = ratingMap[pos][raceType][type]
    const rating = member[key]
    return rating === 1000 ? 0 : rating
  }

  const TeamMember = ({ index, member, pos }) => {
    const navigate = useNavigate()

    return (
      <tr key={index} className='clickable' onClick={() => navigate(`/sailors/${member.sailorID}`)}>
        <td className='tdRightBorder tdLeftBorder tableColFit' style={{ textAlign: 'right' }}>
          {index + 1}
        </td>
        {debug ? (
          <td>
            {member.cross > 20 && member.outLinks > 70 ? 'y' : ''}
            {member.cross},{member.outLinks}
          </td>
        ) : (
          <></>
        )}
        <td className={mobile ? '' : 'tableColFit'}>{decodeURIComponent(member.name)}</td>
        <td className=''>{member.year.split('.')[0].includes('*') ? member.year.split('.')[0].slice(0, 2) : member.year.split('.')[0].slice(2, 4)}</td>
        {mobile ? (
          <td style={{ textAlign: 'right' }} className='tableColFit'>
            {sort === 'races' ? member.numRaces : sort === 'ratio' ? <RatioBar ratio={member.winP} /> : <RatingNum highest={false} sailor={member} pos={pos} type={ratingTypes[ratingView].type} raceType={ratingTypes[ratingView].raceType} />}
          </td>
        ) : (
          <>
            <td style={{ textAlign: 'left', minWidth: 50 }}>
              {/* {rankingOpen ? <TiStarFullOutline style={{ bottom: -5 }} className='secondaryText' /> : ''}
              {rankingWomen ? <TiStarFullOutline className='secondaryText' color='var(--women)' /> : ''} */}
            </td>
            {/* <td className='secondaryText'>{member.gender === 'F' ? 'W' : ''}</td> */}
            <td className='tableColFit' style={{ textAlign: 'left' }}>
              {member.numRaces}
            </td>
            {/* <td style={{ textAlign: 'right' }}>{pos === 'skipper' ? member.avgSkipperRatio.toFixed(3) : member.avgCrewRatio.toFixed(3)}</td> */}
            <td className='tableColFit' style={{ textAlign: 'center' }}>
              {/* <RatioBar ratio={pos === 'skipper' ? member.avgSkipperRatio : member.avgCrewRatio} /> */}
              <RatioBar ratio={member.winP} />
            </td>
            <td></td>
            <td style={{ textAlign: 'right', width: 'min-content' }} className='tableColFit'>
              <RatingNum highest={false} sailor={member} pos={pos} type={'open'} raceType={'fleet'} />
            </td>
            <td style={{ textAlign: 'right' }} className='tableColFit'>
              <RatingNum highest={false} sailor={member} pos={pos} type={'women'} raceType={'fleet'} />
            </td>
            <td style={{ textAlign: 'right' }} className='tableColFit'>
              <RatingNum highest={false} sailor={member} pos={pos} type={'open'} raceType={'team'} />
            </td>
            <td style={{ textAlign: 'right' }} className='tableColFit'>
              <RatingNum highest={false} sailor={member} pos={pos} type={'women'} raceType={'team'} />
            </td>
          </>
        )}
        {/* <td className='tdRightBorder'></td> */}
      </tr>
    )
  }

  const toggleFilter = (season, element) => {
    if (activeSeasons.indexOf(season) !== -1) {
      setActiveSeasons(activeSeasons.filter((reg) => reg !== season))
      // element.classList.add('filterInactive')
    } else {
      setActiveSeasons((activeSeasons) => [...activeSeasons, season])
      // element.classList.remove('filterInactive')
    }
    // console.log(element.classList)
  }

  const selectRating = (team, women) => {
    const view = team ? (women ? 'wteamrating' : 'teamrating') : women ? 'womenrating' : 'openrating'
    setRatingView(view)
    setSort(view)
  }

  const MobileControls = () => {
    const team = ratingView === 'teamrating' || ratingView === 'wteamrating'
    const women = ratingView === 'womenrating' || ratingView === 'wteamrating'

    return (
      <div className='mobileControlsContainer'>
        <div className='mobileControlsGrid'>
          <div style={{ gridArea: '1 / 1 / 1 / 3' }}>
            <label className='fleetTeamSwitch' htmlFor='teamPageTeamCheckbox'>
              <input id='teamPageTeamCheckbox' type='checkbox' checked={team} onChange={(input) => selectRating(input.target.checked, women)} />
              <div className='fleetTeamSlider'></div>
              <div className='fleetTeamSliderLabel'>
                <span>Fleet</span>
                <span>Team</span>
              </div>
            </label>
          </div>
          <div style={{ gridArea: '2 / 1 / 2 / 3' }}>
            <label className='fleetTeamSwitch' htmlFor='teamPageWomenCheckbox'>
              <input id='teamPageWomenCheckbox' type='checkbox' checked={women} onChange={(input) => selectRating(team, input.target.checked)} />
              <div className='fleetTeamSlider'></div>
              <div className='fleetTeamSliderLabel'>
                <span>Open</span>
                <span>Women</span>
              </div>
            </label>
          </div>

          <button onClick={() => setSort(sort === 'races' ? ratingView : 'races')} style={{ backgroundColor: sort === 'races' ? 'var(--border)' : 'var(--bg)' }}>
            Races
          </button>
          <button onClick={() => setSort(sort === 'ratio' ? ratingView : 'ratio')} style={{ backgroundColor: sort === 'ratio' ? 'var(--border)' : 'var(--bg)' }}>
            Win %
          </button>

          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ backgroundColor: 'var(--bg)', gridArea: '2 / 3 / 2 / 5' }}>
            Back to top
          </button>
        </div>
      </div>
    )
  }

  const seasonsChanged = ([start, end]) => {
    setActiveSeasons(allSeasons.slice(allSeasons.indexOf(start), allSeasons.indexOf(end) + 1))
  }

  const PosList = ({ members, pos }) => {
    const seenInThisList = new Set()

    const posMembers = members.filter((member) => member.position === pos && member.teamID === teamName)
    const filtered = posMembers
      .map((member) => {
        // accumulate numRaces across the activeSeasons before filtering so totals reflect all selected seasons
        // sum raceCount for all entries in `members` that match this sailor (by sailorID or name+pos) and are in an active season
        const key = member.sailorID ? `${member.sailorID}` : `${member.name}_${pos}`
        const thisMemberEntries = posMembers.filter((m) => {
          // grab entries of current sailor
          const mKey = m.sailorID ? `${m.sailorID}` : `${m.name}_${pos}`
          return mKey === key
        })

        const numRaces = thisMemberEntries.reduce((total, m) => {
          // sum total races if season is selected
          if (activeSeasons.includes(m.season)) {
            return total + (m.raceCount || 0)
          }
          return total
        }, 0)

        const winStats = thisMemberEntries.reduce(
          (acc, m) => {
            if (activeSeasons.includes(m.season)) {
              acc.sum += m.winPercent
              acc.count += 1
            }
            return acc
          },
          { sum: 0, count: 0 },
        )

        // Calculate average (and handle division by zero just in case)
        const winP = winStats.count > 0 ? winStats.sum / winStats.count : 0
        return { ...member, numRaces, winP }
      })
      .filter((member) => {
        // 2. Filter for active seasons
        let hasSeason = activeSeasons.includes(member.season)
        if (!hasSeason) return false

        // 3. Dedupe using the local Set
        // Using sailorID + position ensures uniqueness within this specific list
        const key = member.sailorID ? `${member.sailorID}` : `${member.name}_${pos}`

        if (seenInThisList.has(key)) return false
        seenInThisList.add(key)

        return true
      })
      .sort((a, b) => {
        if (sort === 'ratio') {
          return b.winP - a.winP
        } else if (sort === 'races') {
          // use the accumulated numRaces
          return (b.numRaces || 0) - (a.numRaces || 0)
        } else if (sort === 'openrating') {
          return getRating(b, pos, 'open', 'fleet') - getRating(a, pos, 'open', 'fleet')
        } else if (sort === 'womenrating') {
          return getRating(b, pos, 'women', 'fleet') - getRating(a, pos, 'women', 'fleet')
        } else if (sort === 'teamrating') {
          return getRating(b, pos, 'open', 'team') - getRating(a, pos, 'open', 'team')
        } else if (sort === 'wteamrating') {
          return getRating(b, pos, 'women', 'team') - getRating(a, pos, 'women', 'team')
        }
        return 0
      })

    return (
      <>
        <div className={mobile ? '' : 'flexGrowChild'}>
          <h2>{pos.slice(0, 1).toUpperCase() + pos.slice(1)}s</h2>
          <table className='raceByRaceTable' style={{ fontSize: '0.9rem' }}>
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Year</th>
                {mobile ? (
                  <th
                    className='tableColFit clickable'
                    style={{ textAlign: 'right' }}
                    onClick={() => {
                      setSort(ratingView)
                    }}>
                    {sort === 'races' ? 'Races' : sort === 'ratio' ? 'Avg Win %' : ratingTypes[ratingView].label}
                    <FaSortDown />
                  </th>
                ) : (
                  <>
                    <th className='tableColFit'></th>
                    <th
                      className='tableColFit clickable'
                      style={{ minWidth: 68 }}
                      onClick={() => {
                        setSort('races')
                      }}>
                      Races{sort === 'races' ? <FaSortDown /> : ''}
                    </th>
                    <th
                      className=' tableColFit clickable'
                      // style={{ textAlign: 'right' }}
                      onClick={() => {
                        setSort('ratio')
                      }}>
                      Avg Win %{sort === 'ratio' ? <FaSortDown /> : ''}
                    </th>
                    <th></th>
                    <th
                      className=' tableColFit clickable'
                      style={{ textAlign: 'right' }}
                      onClick={() => {
                        setSort('openrating')
                      }}>
                      Open Fleet{sort === 'openrating' ? <FaSortDown /> : ''}
                    </th>
                    <th
                      className=' tableColFit clickable'
                      // style={{ textAlign: 'right' }}
                      onClick={() => {
                        setSort('womenrating')
                      }}>
                      Women's{sort === 'womenrating' ? <FaSortDown /> : ''}
                    </th>
                    <th
                      className=' tableColFit clickable'
                      // style={{ textAlign: 'right' }}
                      onClick={() => {
                        setSort('teamrating')
                      }}>
                      Team Race{sort === 'teamrating' ? <FaSortDown /> : ''}
                    </th>
                    <th
                      className=' tableColFit clickable'
                      // style={{ textAlign: 'right' }}
                      onClick={() => {
                        setSort('wteamrating')
                      }}>
                      Women's TR{sort === 'wteamrating' ? <FaSortDown /> : ''}
                    </th>
                  </>
                )}
                {/* <th> </th> */}
              </tr>
            </thead>
            <tbody>
              {filtered.length > 0 ? (
                filtered.map((member, index) => <TeamMember index={index} key={index} member={member} pos={pos} />)
              ) : (
                <tr>
                  <span style={{ width: '50%', position: 'absolute', textAlign: 'center', margin: 20 }}>Please select at least one season!</span>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    )
  }

  return (
    <div>
      {loaded ? (
        <div style={{ padding: 15, paddingBottom: mobile ? 130 : 15 }}>
          <div className='teamPageHeader'>
            <Link to={'/teams'} className='secondaryText'>
              {'<'} All Teams
            </Link>
            <div className='flexRowContainer' style={{ alignItems: 'center' }}>
              <img style={{ display: 'inline', maxHeight: '3rem' }} src={`https://scores.collegesailing.org/inc/img/schools/${teamCodes[teamName]}.png`} />
              <h1 style={{ display: 'inline-block' }}>
                <a href={`https://scores.collegesailing.org/schools/${teamLink}/`} target={1}>
                  {teamName}
                </a>
              </h1>
            </div>

            {/* <Link to={{ pathname: `/teams`, search: `?region=${teamRegion}` }}>
              <span className='filterOption' style={{ backgroundColor: regionColors[teamRegion] }}>
                {teamRegion}
              </span>{' '}
              avg rating: {rating.toFixed(0)}
            </Link> */}
          </div>
          {teamData.fr_rank || teamData.tr_rank || teamData.wfr_rank || teamData.wtr_rank ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <table className='teamRatingContainer'>
                <thead>
                  <tr style={{ height: '3rem' }}>
                    <th>Racing Type</th>
                    <th>National</th>
                    <th>
                      <span className='filterOption' style={{ backgroundColor: regionColors[teamData?.region] }}>
                        {teamData?.region}
                      </span>
                    </th>
                    <th>Avg Rating</th>
                    <th className='teamRatingSailors'>Skippers</th>
                    <th className='teamRatingSailors'>Crews</th>
                  </tr>
                </thead>
                <tbody>
                  {teamData.fr_rank ? <RankingDisplay data={teamData} members={teamMembers} rankType='fr' /> : <></>}
                  {teamData.tr_rank ? <RankingDisplay data={teamData} members={teamMembers} rankType='tr' /> : <></>}
                  {teamData.wfr_rank ? <RankingDisplay data={teamData} members={teamMembers} rankType='wfr' /> : <></>}
                  {teamData.wtr_rank ? <RankingDisplay data={teamData} members={teamMembers} rankType='wtr' /> : <></>}
                </tbody>
              </table>
            </div>
          ) : (
            <></>
          )}

          {selectionMode === 'advanced' ? (
            <div className='flexRowContainer flexWrap' style={{ marginLeft: mobile ? 0 : 15, gap: mobile ? '0.3rem' : undefined, marginTop: mobile ? '1rem' : 0 }}>
              {allSeasons
                .sort((a, b) => {
                  if (parseInt(a.slice(1, 3)) - parseInt(b.slice(1, 3)) !== 0) {
                    return parseInt(a.slice(1, 3)) - parseInt(b.slice(1, 3))
                  } else if (a.slice(0, 1) === 's' && b.slice(0, 1) === 'f') {
                    return -1
                  } else {
                    return 1
                  }
                })
                .map((season, index) => (
                  <div key={index} className={`filterOption`} style={{ backgroundColor: activeSeasons.includes(season) ? 'var(--highlight1)' : '' }} onClick={(e) => toggleFilter(season, e.target)} onDoubleClick={() => setActiveSeasons([season])}>
                    {season?.toUpperCase()}
                  </div>
                ))}
              <button className='filterOption' onClick={() => setActiveSeasons(allSeasons)}>
                Enable all
              </button>
              <button className='filterOption' onClick={() => setActiveSeasons([])}>
                Disable all
              </button>
            </div>
          ) : (
            <DoubleSlider values={allSeasons} initialStart={activeSeasons.slice(-1)[0]} onChange={seasonsChanged} />
          )}
          <div className={mobile ? 'flexCol' : 'responsiveRowCol'} style={{ padding: mobile ? 0 : 15, flexWrap: 'wrap' }}>
            <PosList members={teamMembers} pos='skipper' />
            <PosList members={teamMembers} pos='crew' />
          </div>

          <div className='flexCol'>
            <h2>Season Regattas:</h2>
            {recentRegattas.length > 0 ? (
              <table className='raceByRaceTable'>
                <thead>
                  <tr>
                    <th className='tableColFit'>Date</th>
                    <th>Regatta</th>
                  </tr>
                </thead>
                <tbody>
                  {recentRegattas.slice(0, 20).map((reg, i) => (
                    <tr
                      key={i}
                      className='clickable'
                      onClick={() => {
                        window.open(`https://scores.collegesailing.org/${reg.season}/${reg.regatta}`)
                      }}>
                      <td>{new Date(reg.date).toLocaleDateString(undefined, { timeZone: 'UTC' })}</td>
                      <td className='text-titlecase'>{reg.regatta.replaceAll('-', ' ')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <span>This team hasn't sailed any regattas yet this season!</span>
            )}
          </div>
          {mobile ? <MobileControls /> : <></>}
        </div>
      ) : (
        <Loader show={!loaded} />
      )}
    </div>
  )
}
